import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import { SelectInputPropsType } from "../../interface/input";
import { labelSty, styInput } from "./styles-input";
import { StyledFormControl, StyledMenuItem, StyledSelect } from "./input-verification";

export default function SelectInput({
  label,
  value,
  onChange,
  options,
}: SelectInputPropsType) {
  const theme = useTheme();
  return (
    <Box sx={{ my: 2, width: "100%" }}>
      <InputLabel
        sx={{
          ...labelSty,
          color: theme.palette.common.black,
        }}
      >
        {label}
      </InputLabel>
      <StyledFormControl sx={{ m: 1, width: "100%" }}>
        <StyledSelect
          value={value ?? ""}
          onChange={onChange}
          sx={{ width: "100%", ...styInput }}
        >
          {options?.map((val, id) => (
            <StyledMenuItem key={id} value={val.value}>
              {val.label}
            </StyledMenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    </Box>
  );
}
